"use client";

import { useState } from "react";
import Image from "next/image";
import { useAppContext } from "@/context/Context";

import chatClosedIcon from "../../public/images/home-chat-switch/close.svg";
import chatOpenIcon from "../../public/images/home-chat-switch/open.svg";
import chatClosedIconLight from "../../public/images/light/home-chat-switch/close.svg";
import chatOpenIconLight from "../../public/images/light/home-chat-switch/open.svg";

import HomeChatLayout from "@/components/HomeChat/HomeChatLayout";

/**
 * Botón flotante para abrir / cerrar el Home Chat.
 * Cambia el ícono según:
 *  - estado del chat (abierto / cerrado)
 *  - tema actual (light / dark)
 */
function HomeChatSwitcher() {
  const { isLightTheme } = useAppContext();
  const [isOpen, setOpen] = useState(false);

  // Elegir el ícono correcto según tema + estado
  const icon = !isLightTheme
    ? isOpen
      ? chatClosedIconLight
      : chatOpenIconLight
    : isOpen
      ? chatClosedIcon
      : chatOpenIcon;

  return (
    <>
      <div className="my_switcher home-chat-switcher">
        <ul>
          <li>
            <button
              type="button"
              className={`setColor ${isLightTheme ? "light" : "dark"}`}
              onClick={() => setOpen((v) => !v)}
            >
              <Image src={icon} alt="Chat" />
            </button>
          </li>
        </ul>
      </div>

      {isOpen && <HomeChatLayout onClose={() => setOpen(false)} />}
    </>
  );
}

export default HomeChatSwitcher;
